import { useCallback } from 'react';
import { audioPlayer } from './audioPlayer';

// Plays a *_audio_url value that already comes attached to a useWordsData
// row (words_nouns.singular_audio_url, words_verbs.display_singular_audio_url,
// words_antonyms.word_a_audio_url, the verbTasksBySet items'
// promptAudioUrl, a words_stories step's audio_url, ...). Unlike
// useInstructionAudio, there's no text->url lookup here — the URL is
// already on the row — so this is just a thin, consistently-logged wrapper
// around the shared audioPlayer singleton.
export function useWordAudio() {
  const play = useCallback((url, onEnd) => {
    if (!url) {
      console.error('[wordAudio] no audio_url provided');
      onEnd?.();
      return;
    }
    audioPlayer.play(url).then(onEnd, (error) => {
      console.error('[wordAudio] playback failed for', url, error);
      onEnd?.();
    });
  }, []);

  const stop = useCallback(() => {
    audioPlayer.stop();
  }, []);

  return { play, stop };
}
